<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Отчеты</div>
            <a class="title-block__btn btn-add btn-primary btn"
               :href="route_create_page">Создать
            </a>
        </div>
    </div>

    <div class="filter-table d-flex align-items-center justify-content-start">
        <div class="me-2">
            <div class="filter-table__input-wrap search-control">
                <input @keyup.delete="onDeleteSearchByName()" @keyup.enter="onSearch()" type="text" v-model="name" class="search-control__input form-control" placeholder="Поиск по названию">
                <button class="search-control__input-btn reset-btn">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                              stroke="currentColor" stroke-width="1.667" stroke-linecap="round"
                              stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <table class="service-table table table-striped table-hover align-middle">
        <thead>
            <tr>
                <th scope="col" v-for="elem in thead">
                    <div class="th-inner sortable asc">
                        {{elem}}
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in items">
                <td class="text-center">
                    <div
                        v-if="row.status == 3"
                        style="width: 20px; height: 20px;"
                        class="bg-success rounded-circle"
                        title="Готов к скачиванию"
                    ></div>
                    <div
                        v-if="row.status == 2"
                        style="width: 20px; height: 20px; font-size: 2rem;"
                        class="text-secondary rounded-circle d-flex align-items-center"
                        title="Заполняется"
                    >
                    </div>
                    <div
                        v-if="row.status == 1"
                        style="width: 20px; height: 20px;"
                        class="bg-secondary rounded-circle"
                        title="Создан"
                    ></div>
                </td>
                <td>
                    {{row.name}}
                </td>
                <td>
                    {{row.client}}
                </td>
                <td>
                    {{row.time_from}}
                </td>
                <td>
                    {{row.time_to}}
                </td>
                <td>
                    {{row.created_at}}
                </td>
                <td class="text-center">
                    <div v-if="row.status != 3">
                        Не готов к скачиванию
                    </div>
                    <a v-if="row.status == 3" :href="row.file_path" target="_blank">
                        <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.59375 10.2446C0.751222 10.2446 0.902245 10.3053 1.01359 10.4132C1.12494 10.5211 1.1875 10.6675 1.1875 10.8202V13.6978C1.1875 14.0031 1.31261 14.2959 1.53531 14.5118C1.75801 14.7276 2.06006 14.8489 2.375 14.8489H16.625C16.9399 14.8489 17.242 14.7276 17.4647 14.5118C17.6874 14.2959 17.8125 14.0031 17.8125 13.6978V10.8202C17.8125 10.6675 17.8751 10.5211 17.9864 10.4132C18.0978 10.3053 18.2488 10.2446 18.4062 10.2446C18.5637 10.2446 18.7147 10.3053 18.8261 10.4132C18.9374 10.5211 19 10.6675 19 10.8202V13.6978C19 14.3084 18.7498 14.894 18.3044 15.3257C17.859 15.7574 17.2549 16 16.625 16H2.375C1.74511 16 1.14102 15.7574 0.695621 15.3257C0.250223 14.894 0 14.3084 0 13.6978V10.8202C0 10.6675 0.0625556 10.5211 0.173905 10.4132C0.285255 10.3053 0.436278 10.2446 0.59375 10.2446Z" fill="#64B6F5"/>
                            <path d="M9.07842 12.4937C9.13358 12.5473 9.1991 12.5899 9.27123 12.6189C9.34337 12.6479 9.4207 12.6628 9.4988 12.6628C9.5769 12.6628 9.65423 12.6479 9.72636 12.6189C9.7985 12.5899 9.86402 12.5473 9.91917 12.4937L13.4817 9.04053C13.5932 8.93246 13.6558 8.78588 13.6558 8.63305C13.6558 8.48021 13.5932 8.33364 13.4817 8.22557C13.3702 8.1175 13.219 8.05678 13.0613 8.05678C12.9036 8.05678 12.7524 8.1175 12.6409 8.22557L10.0925 10.6969V0.575536C10.0925 0.422895 10.03 0.276505 9.91864 0.168571C9.80729 0.0606367 9.65627 0 9.4988 0C9.34132 0 9.1903 0.0606367 9.07895 0.168571C8.9676 0.276505 8.90505 0.422895 8.90505 0.575536V10.6969L6.35667 8.22557C6.24518 8.1175 6.09397 8.05678 5.9363 8.05678C5.77863 8.05678 5.62741 8.1175 5.51592 8.22557C5.40443 8.33364 5.3418 8.48021 5.3418 8.63305C5.3418 8.78588 5.40443 8.93246 5.51592 9.04053L9.07842 12.4937Z" fill="#64B6F5"/>
                        </svg>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>
<script>
import ReportTableElement from "./Report/ReportTableElement.vue";
import PaginationElement from "../../../elements/PaginationElement.vue";
import Report from "../../../models/Report";

export default {
    name: "ReportComponent",
    components: {PaginationElement, ReportTableElement},
    props: {
        route_create_page: String,
        route_list: String,
        cdn_url: String
    },
    data: function () {
        return {
            thead: [
                'Статус',
                'Название',
                'Клиент',
                'За период: с',
                'За период: по',
                'Создан',
                ''
            ],
            report: new Report({
                route_list: this.route_list,
            }),
            search: '',
            items: [],
            count: 1,
            limit: 30,
            page: 1,
            name: '',
            client: '',
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.report.loadTable(
                this.page,
                this.limit,
                this.name,
                this.client
            );
            this.items = response.items;
            this.count = response.pages;
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        onDeleteSearchByName: async function () {
            if (this.name.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        onDeleteSearchByClient: async function () {
            if (this.client.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
    },
    mounted() {
        this.loadTable();
    }
}
</script>
<style scoped>
    tbody td {
        padding: 7px 4px !important;
    }
</style>
